<div class="w-full flex flex-col gap-4 p-4">
    <app-page-header urlPath="/Versionamento"></app-page-header>

    <p-card [header]="'Versionamento'" [formGroup]="form">
        <div class="w-full flex flex-col gap-4">
            <div
                class="w-full grid sm:grid-cols-12 grid-cols-1 gap-4 items-end"
            >
                <app-select
                    label="Solução"
                    [options]="selectSolucao"
                    formControlName="IdSolucao"
                    class="sm:col-span-6 sm:col-start-1"
                ></app-select>

                <app-input-double
                    [label]="'Número da Versão'"
                    formControlName="VersaoNumero"
                    class="sm:col-span-3 sm:col-start-1"
                ></app-input-double>

                <app-input
                    [label]="'Versão'"
                    formControlName="VersaoString"
                    class="sm:col-span-3"
                ></app-input>

                <app-checkbox
                    [label]="'Obrigatório'"
                    formControlName="Obrigatoria"
                    class="sm:col-span-3 h-8 flex items-center"
                ></app-checkbox>

                <app-checkbox
                    [label]="'Com Atualização'"
                    formControlName="ComAtualizador"
                    class="sm:col-span-3 h-8 flex items-center"
                ></app-checkbox>

                <app-input
                    [label]="'Descrição'"
                    formControlName="Descricao"
                    class="sm:col-span-6"
                ></app-input>

                <app-input
                    [label]="'Link do Arquivo'"
                    formControlName="Link"
                    class="sm:col-span-6"
                ></app-input>
            </div>

            <div
                class="w-full flex sm:flex-row flex-col gap-4 justify-end items-end"
            >
                @if (
                    form.get("VersaoString")?.value !== "" &&
                    form.get("Link")?.value === ""
                ) {
                    <app-button
                        (click)="modalUpload = true"
                        class="md:max-w-45 w-full"
                        >Selecione o Arquivo</app-button
                    >
                }
                @if (temLink) {
                    <app-button
                        (click)="baixarArquivo()"
                        class="md:max-w-45 w-full"
                        >Baixe o Arquivo</app-button
                    >
                }
            </div>
        </div>
    </p-card>

    <app-footer-page
        [end]="true"
        (confirmar)="processarFormulario()"
        (cancelar)="cancelar()"
        labelConfirmar="Confirmar"
    ></app-footer-page>

    <app-modal-upload-arquivo
        (closeModal)="modalUpload = false"
        [modalVisible]="modalUpload"
        [version]="this.form.get('VersaoString')?.value"
        (dadosSalvos)="receberLink($event)"
    ></app-modal-upload-arquivo>
</div>
